import produce from 'immer';
import { AUTOCOMPLETE_FAILED, AUTOCOMPLETE_FULFILLED } from '../constants/actions/autocompleteActions';
import IPageItem from '../interfaces/autocomplete/pageItem';

type ReducerState = {
	icelandicPages: IPageItem[];
	englishPages: IPageItem[];
	error: boolean;
};

const initialValues: ReducerState = {
	icelandicPages: [],
	englishPages: [],
	error: false,
};

const autocompleteReducer = produce((draft, action) => {
	switch (action.type) {
		case AUTOCOMPLETE_FULFILLED: {
			draft.icelandicPages = action.payload.autocompleteResults.icelandicPages;
			draft.englishPages = action.payload.autocompleteResults.englishPages;
			draft.error = false;
			break;
		}
		case AUTOCOMPLETE_FAILED: {
			draft.icelandicPages = [];
			draft.englishPages = [];
			draft.error = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default autocompleteReducer;
